// const moment = require('moment')
const industryList = require('@/utils/industryList')
const _formRows = [
  {
    span: 24,
    label: '需求名称',
    component: 'AInput',
    placeholder: '请输入需求名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 24,
    label: '需求类型',
    component: 'ARadioGroup',
    prop: 'demandsType',
    radioList: [
      { label: '技术难题', value: '1' },
      { label: '产品需求', value: '2' },
      { label: '服务需求', value: '3' },
      { label: '其他需求', value: '4' }
    ]
  },
  {
    span: 24,
    label: '价格预算',
    component: 'ARadioGroup',
    prop: 'priceRange',
    disabledItem: ['selfRadio'],
    customSetDefault: true, // 特殊处理自定义输入框的默认值
    radioList: [
      { label: '面议', value: -1 },
      {
        label: '自定义',
        isSelf: true,
        style: {
          width: '100px',
          marginTop: '10px'
        },
        inputValue: 0, // 输入框的值
        allowClear: true,
        key: 'selfRadio',
        value: 'selfRadio',
        disabled: true,
        placeholder: '请输入金额'
      }
    ],
    handleCustomResult(instance) {
      if (instance && instance.defaultValue) {
        if (instance.defaultValue !== -1) {
          instance.inputValue =
            this.defaultValue === 'selfRadio'
              ? this.radioInputValue
              : this.defaultValue
          instance.defaultValue = 'selfRadio'
          const t = instance.radioList.find(t => t.label === '自定义')
          t.disabled = false
        }
      }
    }
  },
  {
    span: 24,
    label: '标签',
    component: 'AInput',
    placeholder: '请输入需求标签',
    prop: 'tag',
    allowClear: true
  },
  {
    span: 24,
    label: '发布主体',
    component: 'ARadioGroup',
    prop: 'companyType',
    radioList: [
      { label: '企业', value: '1' },
      { label: '个人', value: '2' },
      { label: '其他', value: '3' }
    ]
  },
  {
    span: 12,
    label: '产业分类',
    component: 'ASelect',
    placeholder: '请输入产业分类',
    prop: 'industrialType',
    allowClear: true,
    list: industryList.industryList
  },
  {
    span: 12,
    label: '技术分类',
    component: 'ASelect',
    placeholder: '请输入技术分类',
    prop: 'technicalType',
    allowClear: true,
    list: [
      { label: '人类生活必需', value: '0' },
      { label: '作业；运输', value: '1' },
      { label: '化学；冶金', value: '2' },
      { label: '纺织；造纸', value: '3' },
      { label: '固定建筑物', value: '4' },
      { label: '机械工程；照明；加热；武器；爆破', value: '5' },
      { label: '物理', value: '6' },
      { label: '电学', value: '7' }
    ]
  },
  {
    span: 24,
    label: '需求描述',
    component: 'ATextArea',
    placeholder: '请输入需求描述',
    prop: 'describe',
    style: {
      height: '78px'
    },
    row: 5,
    allowClear: true
  }
]

const _formRules = {
  name: [
    { required: true, message: '需求名称不能为空', trigger: 'blur' },
    { min: 1, max: 100, message: '输入的字数不能超过100个', trigger: 'blur' }
  ],
  demandsType: [
    { required: true, message: '需求类型不能为空', trigger: ['blur'] }
  ],
  priceRange: [
    { required: true, message: '价格预算不能为空', trigger: ['blur'] }
  ],
  companyType: [
    { required: true, message: '发布主体不能为空', trigger: ['blur'] }
  ],
  describe: [
    { required: true, message: '需求描述不能为空', trigger: ['blur'] }
  ],
  industrialType: [
    { required: true, message: '产业分类不能为空', trigger: ['blur'] }
  ],
  technicalType: [
    { required: true, message: '技术分类不能为空', trigger: ['blur'] }
  ],
  tag: [{ required: true, message: '标签不能为空', trigger: ['blur'] }]
}

const userInfo = [
  { label: '发布人', value: '慕思', key: 'userName' },
  { label: '机构', value: '慕思健康睡眠股份有限公司', key: 'enpName' },
  { label: '手机', value: '13244445555', key: 'phoneNumber' },
  { label: '电话', value: '020-34243456', key: 'enpPhone' },
  { label: '邮箱', value: 'bjhtkzyq@163.com', key: 'email' }
]

const _formInfo = [
  { label: '需求名称', value: '-', key: 'name' },
  { label: '需求类型', value: '-', key: 'demandsTypeStr' },
  { label: '价格预算', value: '-', key: 'priceRange' },
  { label: '发布主体', value: '-', key: 'companyTypeStr' },
  { label: '产业分类', value: '-', key: 'industryListStr' },
  { label: '技术分类', value: '-', key: 'technicalTypeStr' },
  { label: '需求描述', value: '-', key: 'describe' }
]

const filterFormRows = (list) => {
  if(process.env.VUE_APP_KEY === 'SzTech') {
    return list.filter(i => i.label !== '产业分类')
  }
  return list
}

const filterFormRule = (obj) => {
  if(process.env.VUE_APP_KEY === 'SzTech') {
    delete obj.industrialType
  }
  return obj
}

module.exports = {
  formRows: filterFormRows(_formRows),
  formRules: filterFormRule(_formRules),
  userInfo,
  formInfo: filterFormRows(_formInfo)
}
